<template>
  <div class="task-page-background">
    <div class="d-block d-flex justify-content-between align-items-center hamburger-spacer" style="border-bottom: 1px solid #DCDFE6; height: 50px">
      <!--
      <router-link :to="'/goal/'+goalId+'/kanban'" plain>
        <i class="el-icon-close"></i> Close
      </router-link>

      <router-link :to="'/dayplanner'" plain>
        <i class="el-icon-close"></i> Close
      </router-link>
      -->
      <a @click="onClose" class="task-page-top-button">
        <i class="el-icon-close"></i> Close
      </a>

      <router-link
        style="margin-left: auto"
        v-if="$route.name !== 'taskpage-details'"
        :to="'/taskdetails/goal/' + goalId + '/member/' + memberId + '/task/' + $route.params.taskId"
        class="task-page-top-button">
        <i class="el-icon-full-screen"></i> Focus on task
      </router-link>

      <ellipsis-button
        class="mr-3"
        heading="Task Actions"
        :show-options="[ !task_is_volatile ? 'edit' : null, 'slot', task.deleted ? 'restore' : 'archive', 'delete']"
        @edit="onShowTaskModal()"
        @archive="onRemoveTask( true )"
        @delete="onRemoveTask( false )"
        @restore="onRestoreTask()">

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent=";" >
          <font-awesome-icon :icon="['fas', 'share-alt']" class="taskicon" />
          Share
        </el-button>

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent=";" >
          <font-awesome-icon :icon="['fas', 'user-plus']" class="taskicon" />
          Invite user
        </el-button>

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent=";" >
          <font-awesome-icon :icon="['far', 'bell']" class="taskicon" />
          Notifications
        </el-button>
      </ellipsis-button>
    </div>

    <div class="task-page" v-if="!no_access && goal_meta.$ready && task_ready">
      <template v-if="task_is_volatile">
        <div class="m-4" style="background: red; color: white; text-align: center">
          THIS TASK IS VOLATILE <!-- TODO: REMOVE THIS INFO -->
        </div>
      </template>
      <el-alert v-if="task_meta.deleted" type="error" center show-icon :closable="false" class="m-4">
        This task has been achived and can not be edited anymore.
        <!-- TODO: make page non editable, also usefull for bugtracker -->
      </el-alert>
      <!--
        :style="{
          'background-image': 'linear-gradient(#ffffff00 0%, #ffffff 500px), url(\'' + goal_meta.picture + '\')', /* TODO: calculate gradient height */
          'background-size': '100%',
          'background-position': 'top',
          'background-repeat': 'no-repeat'
        }">
      -->
      <div class="m-4 task-page-header">
        <div style="display: flex; flex-direction: row; justify-content: space-between">
          <div class="task-page-header-row1">
            <div class="task-page-headline">
              <el-checkbox
                style="line-height: 3em; margin-right: 0.5em;"
                v-model="task_done"
                :class="{
                  'task-page-task-done': true,
                  'task-page-task-done--pulse': checklist_finished
                }">
              </el-checkbox>

              <div>
                <inline-editable-text
                  @change="task_meta_update({ name: $event })"
                  :value="task_meta.name"
                  :resetOnCancel="false"
                  :inline="true" >
                  <div slot-scope="props" >{{props.text}}</div>
                </inline-editable-text>
              </div>
            </div>
            <div class="task-page-date-header">
              <div class="task-page-date-header__item">
                Due date:
                <date-selector-inline
                  class="task-page-date-header__duedate"
                  size="mini"
                  v-model="task_deadline"
                  placeholder="Pick a day"
                  :default-is-today="true"
                  text_if_empty='none'
                  @save="task_meta_update({deadline: $event})"
                  :disabled="task_done" />
              </div>
              <div class="task-page-date-header__item" v-if="!task.done">
                <font-awesome-icon
                  v-if="task_meta.finishedAt < task_deadline"
                  :icon="['fas', 'trophy']"
                  color="grey"
                  style="margin-left: 0.5em"
                  v-tooltip="{ content: 'Finish task before ' + this.$filters.shortDateTime(task_deadline) + ' to earn this trophy'}" />
              </div>
              <div v-else style="margin-left: 0.5em"></div>
              <div class="task-page-date-header__createdAt">
                Created at:
                {{task_meta.createdAt |shortDate}}
                <!--
                by
                <router-link
                  v-if="task_meta.createdBy"
                  :to="{ name: 'user', params: { userId: task_meta.createdBy }}">
                {{ goal_meta.members[task_meta.createdBy].cachedName }}
                </router-link>
                -->
              </div>
            </div>
            <!--
            <div class="task-page-status">
              <div>
                Status:
              </div>
              <div style="margin-left:0.5em;">
                <div>
                  <div v-show="task_done">
                    completed on {{ task_meta.finishedAt |shortDateTime}}
                    <font-awesome-icon
                      v-if="task_meta.finishedAt < task_deadline"
                      :icon="['fas', 'trophy']"
                      size="lg"
                      color="black"
                      style="margin-left:0.5em"
                      v-tooltip="{ content: 'Task completed before deadline. You rock!'}" />
                  </div>
                  <div v-show="!task_done" >
                    unfinished
                    <font-awesome-icon
                      v-if="task_meta.finishedAt < task_deadline"
                      :icon="['fas', 'trophy']"
                      size="lg"
                      color="grey"
                      style="margin-left:0.5em"
                      v-tooltip="{ content: 'Finish task before ' + this.$filters.shortDateTime(task_deadline) + ' to earn this trophy'}" />
                  </div>

                </div>
              </div>
            </div>
            -->
            <div class="task-page-below-description">
              <div class="task-page-below-description__item">
                <TaskMemberList :goal="goal_meta" :task="task_meta" />

                <div v-if="task_meta.jobstopper" style="border: 2px solid #bf7676; padding: 6px 10px; background: #ff00002e; border-radius: 3px;" class="mb-2">
                  <strong><font-awesome-icon icon="hand-paper" /> Job stopper:</strong>
                  <br />
                  {{task_meta.jobstopper}}
                  (<a href="#" @click.prevent="onClickJobStopper(task_meta.jobstopper)">edit</a>,
                  <a href="#" @click.prevent="task_meta_update({ jobstopper: null })">resolved</a>)
                </div>
                <el-button
                  v-else
                  plain
                  size="mini"
                  v-tooltip="{ content: 'Ask your team for support on this task' }"
                  type="info"
                  @click="onClickJobStopper('')">
                  <font-awesome-icon icon="hand-paper" /> Job stopper
                </el-button>
                <el-button
                  plain
                  size="mini"
                  v-tooltip="{ content: 'This task needs to be done first' }"
                  type="info"
                  @click="onSendTaskToTop('')">
                  Make #1 priority
                </el-button>
              </div>
              <!--
              <div class="task-page-below-description__item">
                <font-awesome-icon :icon="['fas', 'share-alt']" /> Share</div>
              <div class="task-page-below-description__item">
                <font-awesome-icon :icon="['far', 'bell']" style="margin-right:0.3em" /> Notifications
              </div>
              -->
            </div>
          </div>
          <el-card class="task-page-header-row2" v-show="!task_done">
            <div class="task-page-headline" style="margin-left: 0; width: 100%">
              <div class="task-page-timer" style="margin-left: 0; width: 100%">

                <div class="task-page-date-header">
                  <div class="task-page-date-header__item">
                    Estimated remaining duration
                  </div>
                </div>
                <div style="display: flex">
                  <!-- TODO: Sollte die gleichen optionen benutzten, wie im Kanban -->
                  <div>
                    <font-awesome-icon
                      v-if="timer_status !== 'running'"
                      size="lg"
                      style="margin-right: 0.3em; cursor: pointer"
                      :icon="['far', 'play-circle']"
                      v-tooltip="{ content: 'Start Timer'}"
                      @click="onStartTimer(task_meta.durationRemaining)"/>
                    <font-awesome-icon
                      v-if="timer_status === 'running'"
                      size="lg"
                      style="margin-right: 0.3em; cursor: pointer"
                      :icon="['far', 'pause-circle']"
                      v-tooltip="{ content: 'Pause Timer'}"
                      @click="onPauseTimer()" />
                    <font-awesome-icon
                      v-if="timer_status === 'running' || timer_status === 'paused'"
                      size="lg"
                      style="margin-right: 0.3em; cursor: pointer"
                      :icon="['far', 'stop-circle']"
                      v-tooltip="{ content: 'Stop Timer'}"
                      @click="onStopTimer()" />
                  </div>
                  <div>
                    <duration-quick-settings
                      :value="active_task_timer
                        ? task_meta.durationRemaining  - session_time_elapsed
                        : task_meta.durationRemaining"
                      @save="onChangeDurationRemaining($event)"
                      :quickDurationSettings="{
                        '0 min': 0 * 60,
                        '1 min': 1 * 60,
                        '3 min': 3 * 60,
                        '5 min': 5 * 60,
                        '10 min': 10 * 60,
                        '15 min': 15 * 60,
                        '20 min': 20 * 60,
                        '25 min': 25 * 60,
                        '30 min': 30 * 60,
                        '45 min': 45 * 60,
                        '60 min': 60 * 60
                      }">
                    </duration-quick-settings>
                  </div>
                </div>
                <div class="task-page-date-header">
                  <div class="task-page-date-header__item" style="display: flex; flex-wrap: nowrap">
                    Planning status

                    <font-awesome-icon
                      v-if="planningStatusInfo === 'ok'"
                      :icon="['fas', 'info-circle']"
                      size="lg"
                      v-tooltip="{ content: 'The planned duration of your checklist items is ' + parseInt(Math.min(100,planningStatusPercent)) + '% of the available time in this task'}"
                      style="margin-left: 0.3em" />
                    <font-awesome-icon
                      v-if="planningStatusInfo === 'setTime'"
                      :icon="['fas', 'exclamation-circle']"
                      :color="planningStatusColor"
                      size="lg"
                      v-tooltip="{ content: 'Please set a remaining duration by clicking on the time above'}"
                      style="margin-left: 0.3em" />

                      <font-awesome-icon
                      v-if="planningStatusInfo === 'increaseTime'"
                      :icon="['fas', 'exclamation-circle']"
                      :color="planningStatusColor"
                      size="lg"
                      v-tooltip="{ content: 'Please increase the estimated time by click on the time above. \n You need at least ' + showHoursMinutesSeconds(task_duration - task_duration_done) + ' to finish'}"
                      style="margin-left: 0.3em; margin-right: 1em" />

                      <font-awesome-icon
                      v-if="planningStatusInfo === 'planMore'"
                      :icon="['fas', 'exclamation-circle']"
                      :color="planningStatusColor"
                      size="lg"
                      v-tooltip="{ content: 'You should create checklist items for at least 30% of the remaining time to have a good plan'}"
                      style="margin-left: 0.3em; margin-right: 1em" />
                  </div>
                </div>
                <div style="display: flex; flex-wrap: nowrap; align-items: flex-end">
                  <el-progress
                    :percentage="parseInt( Math.min( 100, planningStatusPercent ) )"
                    v-tooltip="{ content: 'Add items to checklist to change this number'}"
                    :color="planningStatusColor"
                    style="width: 180px; margin-bottom: 3px; margin-right: 0.3em"
                    :show-text="false"
                    :stroke-width="12"/>
                    <span class="percentage-text" :style="planningStatusPercent > 100 ? { color: planningStatusColor } : ''">{{ planningStatusPercent.toFixed(1) }}&nbsp;%</span>
                </div>
                <div class="task-page-date-header">
                  <div class="task-page-date-header__item">
                    Estimated total duration:
                    {{ showHoursMinutesSeconds( task_meta.durationRemaining + recorded_sessions_duration ) }}
                    <font-awesome-icon
                      :icon="['fas', 'info-circle']"
                      v-tooltip="{ content: 'Duration of already completed checklist items + estimated remaining duration'}"
                      style="margin-left: 0.3em" />
                  </div>
                </div>
                <div class="task-page-date-header">
                  <div class="task-page-date-header__item">
                    Estimated completion date
                    <font-awesome-icon
                      :icon="['fas', 'info-circle']"
                      v-tooltip="{ content: 'The estimated completion date is calculated based on the remaining duration of this task and your personal schedule that takes into account all your tasks and priorities'}"
                      style="margin-left: 0.3em" />
                  </div>
                </div>
                <div class="task-page-date-header">
                  <div class="task-page-date-header__item">
                    <div v-if="optimizer_finish_dates_tasks[task.$id] && optimizer_finish_dates_tasks[task.$id] > 0" class="task-page-date-header__item">
                      <font-awesome-icon
                        :icon="['fas', 'flag-checkered']"
                        style="margin-right: 0.3em"
                        v-tooltip="{
                          content: 'Estimated completion date: <br>'
                            + $options.filters.shortDateTime(optimizer_finish_dates_tasks[task.$id] * 1000)
                            + ', which is in '
                            +  $options.filters.fromNow(optimizer_finish_dates_tasks[task.$id] * 1000) }"/>
                        {{ $options.filters.shortDateTime(optimizer_finish_dates_tasks[task.$id] * 1000) }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </el-card>
          <div class="task-page-header-row2" v-show="task_done">
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
              <div class="task-page-status">
                Completed on {{ task_meta.finishedAt |shortDateTime}}
              </div>
              <div>
                <font-awesome-icon
                  v-if="task_meta.finishedAt < task_deadline"
                  :icon="['fas', 'trophy']"
                  size="3x"
                  color="gold"
                  style="margin-left: 0.5em"
                  v-tooltip="{ content: 'Task completed before deadline. You rock!'}" />
              </div>
              <div>
                You finished on time and earned a trophy!
              </div>
              <div style="display: flex; align-items: center ">
                <font-awesome-icon
                  v-if="task_meta.finishedAt < task_deadline"
                  :icon="['fas', 'check']"
                  size="sm"
                  style="margin-right: 0.5em"
                  v-tooltip="{ content: 'Has been seen by other people'}" />
                  Achim, Thomas and 5 others have seen this
              </div>
            </div>
          </div>

            <!--
            <el-button type="text" @click="onRemoveTask" >
              <font-awesome-icon icon="trash" size="lg" />
            </el-button>
            -->
        </div>

        <hr class="my-4"/>

        <collapse-group title="Description" :init-collapse="!task_meta.description" class="mb-2">
          <!--
          <el-button @click="showDescription = !showDescription" size="small" class="mb-2">
            <font-awesome-icon icon="eye" /> {{ showDescription ? 'hide' : 'show' }} description
          </el-button>
          -->

          <div class="task-page-description" style="position: relative;">
            <!-- TODO: if now description, show that now description exists + button "create description" -->
            <!--
            <EditableMultilineText
              @update="task_meta_update({ description: $event })"
              :text="task_meta.description"
              :show-as-markdown="true" />
            -->
            <markdown-text
              :value="task_meta.description"
              @input="task_meta_update({ description: $event })"
              :enable-inline-editing="true" />
          </div>
        </collapse-group>

        <!-- - - - - - - - - - - - - - CHECKLIST - - - - - - - - - - - - - - -->
        <TaskPageChecklist
          ref="checklist"
          class="mb-2"
          :checklist-ids="checklist_ids"
          :task-is-volatile="task_is_volatile"
          :task-meta="task"
          :goal-id="goalId"
          :member-id="memberId"
          @checklist-finished="checklist_finished = $event"
          @update-duration="task_duration = $event"
          @update-duration-done="task_duration_done = $event" />
        <!-- - - - - - - - - - - - -  /CHECKLIST - - - - - - - - - - - - - - -->

        <!--<collapse-group title="Task Activity in Minutes" :init-collapse="true">
          <TaskPageActivityGraph :recorded_sessions="recorded_sessions" :task_meta="task_meta" />
        </collapse-group>-->

        <!-- - - - - - - - - - - - - - COMMENTS - - - - - - - - - - - - - - -->
        <TaskPageComments
          v-if="task && task.$ready && !task_is_volatile"
          class="mb-2"
          :task="task"
          :member-id="memberId" />
        <!-- - - - - - - - - - - - -  /COMMENTS - - - - - - - - - - - - - - -->

        <collapse-group
          title="Attachments"
          :init-collapse="Object.keys(task.attachments || []).length === 0"
          class="task-page-attachments clearfix mb-2">
          <!-- TODO: component -->
          <template v-if="task.attachments">
            <!-- TODO: only if mime type image! -->
            <el-card
              v-for="(attachment_url, attachment_id) in task.attachments"
              :key="attachment_id"
              style="width: 200px; height: 185px; float: left;"
              body-style="padding: 0"
              class="mr-4 mt-4">

              <div v-if="!attachment_mime[ attachment_id ]">
                Loading...
              </div>
              <div v-else>
                <a
                  v-if="attachment_mime[ attachment_id ].preview"
                  :href="attachment_url"
                  target="_blank"
                  class="task-image"
                  :style="{
                    'background-image': 'url(\'' + attachment_url + '\')',
                  }">
                </a>
                <a
                  v-else
                  :href="task.attachments[ attachment_id ]"
                  target="_blank"
                  class="text-center d-block"
                  style="height: 145px; padding-top: 45px;">
                  <font-awesome-icon
                    :icon="[ 'far', attachment_mime[ attachment_id ].icon ]"
                    size="4x"
                    style="margin: 1px" />
                </a>
              </div>

              <ellipsis-button
                class="mr-2 mt-1"
                style="float: right"
                heading="Attachment actions"
                :show-options="['delete']"
                @delete="onDeleteAttachment(attachment_id)">
              </ellipsis-button>
              <!--
              <el-button
                style="margin: 5px auto;"
                size="mini"
                type="danger"
                @click.prevent="onDeleteAttachment(attachment_id)">
                <font-awesome-icon icon="trash-alt" />
                Delete attachment
              </el-button>
              -->
            </el-card>
          </template>

          <el-card style="width: 200px; float: left;" class="mr-4 mt-4">
            <div
              :class="{
                'task': true,
                'file-drop-zone': true,
                'file-drop-zone--active': active_drop_target,
                'file-uploading': attachment_uploading,
              }"
              style="min-height: 150px; text-align: center; color: gray"
              @drop.prevent.stop="onDropAttachment"
              @dragover="onDragOver"
              @dragleave="onDragLeave">

              <span style="pointer-events: none">Drop files here</span>
              <!-- TODO: Click should open file selector -->
              <div v-if="attachment_uploading" class="spinner-container">
                <i class="d-block el-icon-loading" style="font-size: 24pt"/>
              </div>
            </div>
          </el-card>

        </collapse-group>
      </div>

      <!--
      <router-link :to="'/goal/'+goalId+'/kanban'" tag="el-button" plain class="d-block w-100 mt-4">
        <i class="el-icon-back"></i> Go back to Tasklist
      </router-link>
      -->

      <!-- <pre class="mini-pre">{{memberId}}</pre> -->
      <!-- <pre class="mini-pre">{{task_meta}}</pre> -->
      <!-- <pre class="mini-pre">Goal ID: {{goalId}}</pre> -->
      <!-- <pre class="mini-pre">task_meta: {{task_meta}}</pre> -->

    </div>
    <div v-else-if="no_access">
      <!-- TODO: nice message -->
      <span>You don't have access to this task.</span>
    </div>
    <div v-else>
      <span>Loading...</span>
    </div>
  </div>
</template>

<script>
import util from "@/util";
import TaskMemberList from '@/components/TaskPage/Elements/TaskMemberList'
import TaskPageComments from "@/components/TaskPage/Elements/TaskPageComments"
import TaskPageChecklist from "@/components/TaskPage/Elements/TaskPageChecklist"
import { mapGetters, mapActions } from "vuex";
import TaskAttachmentMixin from '@/components/Mixins/TaskAttachment'
import TaskManagementMixin from "@/components/Mixins/TaskManagement"
//import TaskPageActivityGraph from "@/components/TaskPage/Elements/TaskPageActivityGraph"
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"

// TODO: Make use of existing API:
//  this.$api.task_create_checklist_item({ goal_id, task_id, data })
//  this.$api.task_update_checklist_item({ goal_id, task_id, item_id, data })
//  this.$api.task_move_checklist_items_batch({ goal_id, task_id, batch })
//  this.$api.task_rem_checklist_item({ goal_id, task_id, item_id })

// TODO: Adapt template according to 'this.task_meta.access.allow_to_edit_tasks'

export default {
  name: "TaskPage",
  mixins: [ TaskAttachmentMixin, TaskManagementMixin, ConfirmDeletePromptMixin ],
  data: () => ({
    newChecklistItem: {
      $id: 'newItem',
      name: '',
      parent: '0',
      sortidx: 1,
      disabled: true,
      visible: false,
      visibleFromInit: false,
      children: []
    },
    task_is_volatile: true,
    no_access: false,
    task_ready: false,
    active_drop_target: false,
    checklist_ids: null,
    task_duration: 0,
    task_duration_done: 0,
    checklist_finished: false,
    task_attachment_list: [],
  }),
  created() {
    // TODO: Move this to store
    const log = (...args) => {}

    this.setAttachmentScope('all');

    log("[TaskPage] Created", this.$route.params)

    const onTaskReady = (goalId, taskId, memberId) => {
      /* this.taskChecklistModel = this.$models.taskChecklistItem.with({
        goalId: goalId,
        taskId: taskId,
        uid:    memberId,
      }) */
      // this.$refs.checklist.onTaskReady(goalId, taskId, memberId);
      this.checklist_ids = { goalId, taskId, memberId }

      this.task.api_delete = (soft_delete) => {
        // INFO: This is reinventing task.remove()
        return this.$api.task_delete({
          task_id:   taskId,
          goal_id:   goalId,
          member_id: memberId,
          soft_delete: soft_delete,
        });
      }

      // this.task.taskId = taskId;
      // this.task.memberId = memberId;
      this.task.goalId = goalId; // used in mixin
      this.task_ready = true;

      /*
      this.$message({
        type: 'success',
        message: 'Now working on: ' + this.task.name
      });
      */
    }

    if ( this.$route.params.sequenceId ) {
      log("[TaskPage] Fake Sequence Task")

      /* This means we klicked on a session and the task does not exist yet */
      let goalId = this.$route.params.goalId;
      let memberId = this.$models.user.defaultUserId /* User is always current user for sequences */

      let sequenceId = this.$route.params.sequenceId
      let sequenceItemId = this.$route.params.sequenceItemId
      let [ itemIdx, actionIdx ] = sequenceItemId.split(':')
      // TODO: let [ itemIdx, actionIdx, sessionRepeat ] = sequenceItemId.split(':')

      log("[TaskPage] - sequenceId", sequenceId)
      log("[TaskPage] - sequenceItemId", sequenceItemId)
      log("[TaskPage] - itemIdx", itemIdx)
      log("[TaskPage] - actionIdx", actionIdx)

      // /* Load sequence and assign names */
      let sequence = this.$models.sequence.subscribeNode( sequenceId )
      sequence.$promise.then(() => {

        log("[TaskPage] sequence", sequence)

        let sequenceSessionGroup, sequenceSessionAction
        try {
          // TODO: Sequence might have changed here and data is not availabe anymore
          sequenceSessionGroup = sequence.$state.sequenceItemList[ itemIdx ]
          sequenceSessionAction = sequenceSessionGroup.actions[ actionIdx ]

          log("[TaskPage] sequenceSessionGroup", sequenceSessionGroup)
          log("[TaskPage] sequenceSessionAction", sequenceSessionAction)
        } catch (e) {
          console.warn(e)
          console.error("[TaskPage] Sequence items does not exists anymore. Outdated data from optimizer?")
          return
        }

        let sequenceItemId = itemIdx // HACK (should be a push id)
        let actionId = actionIdx     // HACK (should be a push id)
        let sessionRepeat = 1        // HACK

        /* Since task does not exist yet, generate new task id */
        let taskId = `${sequenceId}:${sequenceItemId}:${actionId}:${sessionRepeat}`
        log("[TaskPage] Generated taskId", taskId)

        /* Check if task already exits */
        /* Checking access rights is not necessary, because memberId is current user */
        this.task = this.$models.task.with({ goalId, memberId }).getNodeFull( taskId )

        this.task.$promise.then(() => {
          // xTODO: Does not work when previously synced as list

          /* Check if task exist, by checking if createdAt exists */
          // if ( this.task.$state['.exists'] && this.task.$state['.exists'] === false ) {
          if ( this.task.createdAt === undefined ) {
            log("[TaskPage] Task not found in DB")
            // this.task = this.$models.task.newFromSequenceItem(sequenceId, sequenceItemId)
            this.task = this.$models.taskMeta.with({ goalId, uid: memberId }).new_from_template()

            /* Copy sequence details to task */
            this.task.$id = taskId
            this.task.description = sequenceSessionGroup.description
            this.task.name = sequenceSessionGroup.title
            this.task.duration = sequenceSessionAction.sessionLength
            this.task.durationRemaining = sequenceSessionAction.sessionLength
            log("[TaskPage] updated task", this.task)

            // TODO: Copy checklist items from sequence template

            this.task_is_volatile = true;
          } else {
            log("[TaskPage] Task found in DB")
            this.task_is_volatile = false;
          }
          onTaskReady(goalId, taskId, memberId)
        })
      })

    } else {
      log("[TaskPage] Existing Task")

      let memberId       = this.memberId;
      let goalId         = this.$route.params.goalId;
      let taskId         = this.$route.params.taskId;

      let make_volatile_task_based_on_template = this.$route.path.includes('task-template');
      let templateTaskId = taskId;

      try {
        this.task = this.$models.task.with({ goalId, memberId }).getNodeFull( templateTaskId )
      } catch ( error ) {
        if ( error.constructor.name === 'NoAccessError' ) { // TODO: might not work in production
          this.task_ready = true;
          this.no_access = true;
          return
        }
        throw error;
      }

      if ( make_volatile_task_based_on_template ) {
        console.log("[TaskPage] Creating volatile task based on template task")

        this.task.$promise.then(() => {

          let currentUserId = this.$models.user.defaultUserId

          this.task = this.$models.taskMeta
            .with({ goalId, uid: memberId })
            .new_from_template({ userId: currentUserId }, this.task.$state)

          let taskId = this.$models.taskMeta._get_uid()
          this.task.$id = taskId
          // TODO TEST: funktioniert das auch für checklist items?

          onTaskReady(goalId, taskId, memberId)
          this.task_is_volatile = true;

          // /* Make all dirty */
          // this.task._update_data( this.task.$state, null, true );

          // TODO: Do not copy description
        })
      } else {
        this.task.$promise.then(() => {
          onTaskReady(goalId, taskId, memberId)
          this.task_is_volatile = false;
        })
        this.task_is_volatile = false; // necessary ??
      }
    }
  },
  computed: {
    ...mapGetters('optimizer', [
      'optimizer_finish_dates_tasks',
    ]),

    ...mapGetters('session', [
      'session_timer_status',
      'session_user_timer',
      'session_time_elapsed',
      'session_timer_taskId',
    ]),

    // ...mapGetters("goal", [
    //   "unsorted_tasks"
    // ]),

    active_task_timer() {
      if (this.session_timer_taskId) {
        return (this.session_timer_taskId ===  this.task.$id && this.session_timer_status(this.task.$id) === 'running')
      } else {
        return false
      }
    },

    timer_status() {
      return this.session_timer_status(this.task_meta.$id)
    },

    memberId() {
      return this.$route.params.memberId || 'TEAM'
    },

    goalId() {
      return this.$route.params.goalId
    },

    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },

    task_meta() {
      return this.task;
    },

    task_done: {
      get() {
        if (this.task_meta.$ready) {
          return this.task_meta.done
        } else {
          return false
        }
      },
      set(done) {
        if (done && this.timer_status === 'running' && this.session_user_timer.taskId && this.session_user_timer.taskId === this.task_meta.$id) { // if timer of this task is running
          this.onStopTimer()
        }
        this.onCheckTask(done)
      }
    },

    task_deadline: {
      get() {
        if (this.task_meta.$ready) {
          return this.task_meta.deadline
        } else {
          return false
        }
      },
      set(deadline) {
        this.task_meta_update({ deadline: deadline })
      }
    },

    planningStatusPercent() {
      let taskDurationRemaining = this.session_timer_taskId === this.task_meta.$id
        ? this.task_meta.durationRemaining - this.session_time_elapsed
        : this.task_meta.durationRemaining
      if (taskDurationRemaining > 0) {
        return ((this.task_duration - this.task_duration_done) / taskDurationRemaining) * 100
      } else if (this.task_duration > 0) {
        return 100
      } else {
        return 0
      }
    },

    planningStatusInfo() {
      let taskDurationRemaining = this.session_timer_taskId === this.task_meta.$id
        ? this.task_meta.durationRemaining - this.session_time_elapsed
        : this.task_meta.durationRemaining
      if (taskDurationRemaining === 0 && this.task_duration === 0) {
        return 'setTime'
      } else if (
        (taskDurationRemaining > 0 && taskDurationRemaining < this.task_duration - this.task_duration_done )
        || (taskDurationRemaining === 0 && this.task_duration - this.task_duration_done > 0)
      ) {
        return 'increaseTime'
      } else if (this.planningStatusPercent < 30) {
        return 'planMore'
      } else {
        return 'ok'
      }
    },

    planningStatusColor() {
      if (this.planningStatusInfo === 'setTime') {
        return '#ed6b06'
      } else if (this.planningStatusInfo === 'increaseTime') {
        return '#e30613'
      } else if (this.planningStatusInfo === 'planMore') {
        return '#ed6b06'
      } else {
        return '#009f3c'
      }
    },

    recorded_sessions() {
      return this.$models.taskRecordedSession
      .with({
        goalId: this.goalId
      })
      //.subscribeQuery({ key: 'createdAt', startAt: 123456789, limit: 100 })
      .subscribeQuery({ key: 'taskId', value: this.task_meta.$id })
      /*return this.$models.taskRecordedSession.getters.get_recorded_sessions_all_goals[this.goalId]
        .filter(item => item.taskId === this.task_meta.$id)*/
    },

    // min_sortidx_in_commitment() {
    //   /*if (this.goalId) {
    //     let all_nodes = this.unsorted_tasks(this.goalId); //  this.task_meta.laneId
    //     return all_nodes//[0]//.sortidx
    //   } else {
    //     return null
    //   }*/
    //   return this.unsorted_tasks(this.goalId)
    // }

    recorded_sessions_duration() {
      let recorded_sessions_duration = 0
      if (this.recorded_sessions.$readyAll) {
        console.log('recorded_sessions_duration', this.recorded_sessions, this.recorded_sessions.length)
        let recordings = this.recorded_sessions.itemsAsArray()
        for (let i = 0; i < recordings.length; i++) {
          recorded_sessions_duration += recordings[i].duration
        }
      }
      return recorded_sessions_duration
    },
  },
  methods: {
    /* onCheckTask     --> TaskManagement Mixin */
    /* onTaskSetLabel  --> TaskManagement Mixin */
    /* onSetTaskName   --> TaskManagement Mixin */
    /* onRestoreTask   --> TaskManagement Mixin */
    /* onShowTaskModal --> TaskManagement Mixin */
    /* onDuplicateTask --> TaskManagement Mixin */
    /* onRemoveTask    --> TaskManagement Mixin */
    /* onStartTimer    --> TaskManagement Mixin */

    ...mapActions('session', [
      'session_timer_reset'
    ]),

    task_meta_update(payload) {
      /* Overwrites mixin method! */
      console.log("task meta update: mixin");
      if (this.task_is_volatile ) {
        this.task_meta.write().then(() => {
          this.task_meta.update(payload) // Testing
          this.task_is_volatile = false;
        })
        return
      }
      if (this.task_ready) {
      // TODO: Check this.task_meta.access.allow_to_edit_tasks
        this.task_meta.update(payload)
      }
    },

    onChangeDurationRemaining(durationRemaining) {
      console.log('onChangeDuration', durationRemaining)
      this.task_meta_update({ durationRemaining: durationRemaining })
      if (this.active_task_timer) {
        this.session_timer_reset({ durationRemaining })
      }
      if (durationRemaining === 0) {
        this.$confirm('Do you want to mark this task as done?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            if (this.session_user_timer.taskId && this.session_user_timer.taskId === this.task_meta.$id) {
              this.onStopTimer()
            }
            this.onCheckTask(true)
          })
      }
    },

    showHoursMinutesSeconds(seconds) { // DOPPELT: showHoursMinutesSeconds -> filter
      if (seconds > 0) {
        return util.showHoursMinutesSeconds(seconds  * 1000)
      } else {
        return '0 min'
      }
    },

    onRemoveTask(soft_delete) {
      /* Overwrites mixin method! */
      if ( soft_delete ) {
        return this.task.api_delete(true).then(() => {
        })
      }

      this.$confirm_delete_prompt('task').then(({ notify }) => {
        this.task.api_delete(false).then(() => {
          notify();
          this.$router.push({ path: `/goal/${this.goalId}/kanban` })
        })
      }).catch(e => e)
    },

    onClose() {
      if ( this.$route.name === 'dayplanner-taskpage' ) {
        this.$router.push('/dayplanner')
      }
      if ( this.$route.name === 'taskpage' || this.$route.name === 'taskpage-details' ) {
        // let to_path = this.$route.path.substr(0, this.$route.path.indexOf('/member'))
        this.$router.push('/goal/' + this.goalId)
      }
    },

    onShowTaskModal() {
      /* Overwrites mixin method! */
      if ( !this.task_is_volatile ) {
        this.$root.showUpdateModal('task', {
          memberId: this.memberId,
          goalId:   this.goalId,
          taskId:   this.task.$id
        })
      }
    },

    onDragOver(event) {
      console.log("onDragOver",  event.dataTransfer.effectAllowed );
      /* Workaround to detect if object being dragged is a file */
      // TODO: This needs more testing...
      if ( event.dataTransfer.effectAllowed === 'all' ) {
        this.active_drop_target = true;
      }

      // TODO: move to mixin
      if ( this.active_drop_target ) {
        event.preventDefault();
        event.stopPropagation();
      }
    },

    onDragLeave(event) {
      this.active_drop_target = false;
    },

    onClickJobStopper( existing_value ) {
      this.$prompt('Please describe the job stopper', 'Ask team for support', {
        inputValue: existing_value || '',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.task_meta_update({ jobstopper: value })
      }).catch(() => {});
    },

    onSendTaskToTop() { // move to mixin
      let tasks = this.$models.taskMeta
        .with({
          goalId: this.goalId,
          uid: this.memberId
        })
        .getList()
        .itemsAsArray()
        .filter(item => item.laneId === this.task_meta.laneId)
        .sort(util.sorter.by_sortidx)

      if (tasks.length > 0) {
        let minSortidx = tasks[0].sortidx
        if (this.task.sortidx !== minSortidx) {
          this.task.update({ sortidx: minSortidx - 1 })
        }
      }
    },
  },
  components: {
    TaskMemberList,
    //TaskPageActivityGraph,
    TaskPageComments,
    TaskPageChecklist,
  }
};
</script>

<style>
.task-page {
  /* Use "linear-gradient" to add a darken background effect to the image (photographer.jpg). This will make the text easier to read */

  /* Set a specific height */
  /* Position and center the image to scale nicely on all screens */
  position: relative;
  margin: 0;
  margin: 0 auto;

  /* scroll */
  overflow-y: scroll;
  height: calc(100vh - 50px);
}
.task-page .el-card {
  background-color: transparent;
  /*overflow: auto !important;*/
  /* overwrite default behaviour */
}
.task-page .el-card__body {
  background-color: rgba(255, 255, 255, 0.9);
}
.task-page-header-row1 {
  display: flex;
  flex-direction: column;
  /*width: 55%*/
}
.task-page-header-row2 {
  margin-left: 1em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  /*width: 40%;*/
}
.task-page-headline {
  font-size: 22pt;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
}
.task-page-status {
  /* font-size: 10pt; */
  /* font-weight: bold; */
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  /* ---- */
  font-size: 14pt;
  margin-bottom: 10px;
  margin-top: 0.5em;
  font-weight: 600;
  color: #74c200;
}
.task-page-timer {
  font-size: 22pt;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.task-page-timer__time {
  display: flex;
  flex-wrap: nowrap;
}
.task-page-timer__duration {
}
.task-page-date-header {
  margin-top: 2px;
  font-size: 10pt;
  /*float: right;*/
  /* margin-left:0.3em; */
  display: flex;
  justify-content: flex-start
}
.task-page-date-header__item {
  margin-right: 0.5em
}
.task-page-date-header__duedate:hover {
  text-decoration: underline;
  text-decoration-style: double;
  text-decoration-color: #409eff;
  cursor: pointer;
}
.task-page-date-header__createdAt {
  color: gray
}
.task-page-date-header__finishedAt {
  font-size: 10pt;
  /*float: right;*/
  /* margin-left:0.3em; */
  display: flex;
  justify-content: flex-start
}
.task-page-description {
  /*
  width: 100%;
  min-width: 300px;
  min-height: 30px;
  padding: 0.5em;
  margin-top: 1em;
  border: 1px dashed
  width:100%;
  min-height: 30px;
  background-color: #eeeeee;
  padding: 0.5em;
 */
}
.task-page-task-done {
  font-weight: bold;
  margin: 0;
}
.task-page-below-description {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5em;
}
.task-page-below-description__item {
  width: 100%;
  /* margin-left: 1em; */
}
.task-page-background {
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100%;
  background-color: #fffffff0;
}
.task-page-duration {
  line-height: 14px;
  margin-left: 0.5em;
  margin-right: 0.5em;
  border: 1px;
  /* font-size: 10pt;
  background-color: #f5f5f5;
  padding: 3px 5px;
  margin: 0 40px 0 0; */
}
.task-page-duration-row {
  width: calc(30vw);
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  /* Correct margins to match height of 1st column */
  margin-top: 0;
  margin-bottom: 1px;
}
.task-page-duration-row .spacer {
  height: 18px;
}
.task-page-duration-row__item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #b7b7b7;
  margin: 0;
  padding: 0;
  height: 20px;
  /* height: 50px; */
  font-size: 14px;
}
.task-page-task-done .el-checkbox__input .el-checkbox__inner {
  width: 18pt;
  height: 18pt;
  /* border-radius: 100%; */
}
.task-page-task-done .el-checkbox__input .el-checkbox__inner::after {
  border-bottom: 4px solid white;
  border-right: 4px solid white;
  height: 12px;
  left: 8px;
  top: 2px;
}
.task-page-task-done .el-checkbox__input.is-checked .el-checkbox__inner,
.task-page-task-done .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #67c23a;
  border-color: #3e861a;
  border-radius: 50%;
}
.task-page-task-done .el-checkbox__inner::after {
  border-bottom: 3px solid white;
  border-right: 3px solid white;
  height: 10px;
  left: 6px;
  top: 2px;
}
.task-page-task-done--pulse .el-checkbox__input .el-checkbox__inner {
  animation: pulse-border-color 2s infinite
}
/*
.task-page-progress {
  margin-top: 1em
}
*/
.task-page-estimated-date {
  margin-top: 1em
}
/* (REBASE 10.3.2019) */
.task-page-unfinished {
}
@keyframes pulse-border-color {
  0% {
    border-color: gray;
  }
  50% {
    border-color: rgb(64, 158, 255);
    background-color: rgb(64, 158, 255, 0.05);
  }
  100% {
    border-color: gray;
  }
}
.task-page .task-image {
  display: block;
  height: 145px;
  background-size: cover;
  background-position-y: center;
}
.task-page .task-image:hover::after {
  content: 'open in new tab';
  color: black;
  text-align: center;
  display: block;
  text-decoration: none;
  background: #ffffffc2;
  padding: 0.2em;
}
.task-page .task-image:hover {
  filter: grayscale(60%);
}

.task-page .file-uploading {
  border-color: grey !important;
}
.task-page .file-drop-zone > * {
  opacity: 1 !important;
}
.task-page .file-drop-zone.file-drop-zone--active {
  border-color: #467fcf !important;
}
.task-page .percentage-text {
  font-size: 10pt
}
.task-page .collapse-group-content {
  padding-left: 0;
}
.task-page-top-button:hover {
  background-color: #efefef;
  text-decoration: none !important;
}
.task-page-top-button {
  height: 100%;
  color: black;
  padding: 14px 1em;
  cursor: pointer;
}
.task-page .collapse-group-header {
  /* font-size: 9pt;
  font-weight: bold;
  color: #666;
  text-transform: uppercase; */
}
</style>
